import { useTranslation } from 'react-i18next';

import { Badge, BadgeVariant } from '@/components/ui/badge';

export type InitiatedBy = 'customer' | 'merchant';

export interface InitiatedByBadgeProps {
  initiatedBy: InitiatedBy | null | undefined;
  className?: string;
}

const getInitiatedByBadgeVariant = (initiatedBy: InitiatedBy): BadgeVariant => {
  if (initiatedBy === 'customer') return 'blue';
  if (initiatedBy === 'merchant') return 'orange';
  return 'default';
};

export function InitiatedByBadge({ initiatedBy, className }: InitiatedByBadgeProps) {
  const { t } = useTranslation('common');

  if (!initiatedBy) {
    return (
      <Badge variant="default" className={className}>
        N/A
      </Badge>
    );
  }

  return (
    <Badge variant={getInitiatedByBadgeVariant(initiatedBy)} className={className}>
      {t(`initiatedBy.${initiatedBy}`, initiatedBy)}
    </Badge>
  );
}
